// Copyright (c) AdCritter. All rights reserved.

import { FC } from 'react'

import { EuiFlexGroup, EuiFlexItem, EuiHorizontalRule, EuiSpacer, EuiTitle } from '@elastic/eui'

import { AIPlanPreview } from 'api/entities/AIPlanPreview'
import AIPlannerMarkdownRenderer from 'pages/MasterCampaignPlanPage/new/components/AIPlannerMarkdownRenderer'

import ReadOnlyStructuredMarketAnalysis from './ReadOnlyStructuredMarketAnalysis'

interface AIPlanMarketAnalysisProps {
  aiPlan: AIPlanPreview
}

const AIPlanMarketAnalysis: FC<AIPlanMarketAnalysisProps> = ({ aiPlan }) => {
  const section = aiPlan.marketAnalysisSection

  const introductionTitle = section?.introduction?.title || 'Market Analysis & Strategy'
  const introductionContent = section?.introduction?.content || `## ${aiPlan.companyName}\n\n---`

  return (
    <>
      <EuiHorizontalRule />

      {section?.introduction?.hideAll !== true && (
        <>
          <EuiFlexGroup alignItems='center' gutterSize='s' responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiTitle size='m'>
                <h3>{introductionTitle}</h3>
              </EuiTitle>
            </EuiFlexItem>
          </EuiFlexGroup>
          <div style={{ paddingTop: 24 }}>
            <AIPlannerMarkdownRenderer content={introductionContent} />
          </div>
          <EuiSpacer size='xl' />
        </>
      )}

      <ReadOnlyStructuredMarketAnalysis marketAnalysis={aiPlan.marketAnalysis} marketAnalysisSection={section} />
    </>
  )
}

export default AIPlanMarketAnalysis
